module.exports = __webpack_public_path__ + "img/cobra.cd8d7df1.jpg";